import Vue from 'vue'
import Image from './Image'
import SplitLabel from './SplitLabel'
import {
  Button, Tabbar, TabbarItem,
  Form, Field, Toast, Checkbox,
  Step, Picker, Popup, Loading, DatetimePicker, Steps, DropdownMenu, DropdownItem, Uploader, Collapse, CollapseItem, Dialog } from 'vant'
const installVant = () => {
  Vue.use(Field)
  Vue.use(Popup)
  Vue.use(Loading)
  Vue.use(DatetimePicker)
  Vue.use(Popup)
  Vue.use(Picker)
  Vue.use(Dialog)
  Vue.use(Collapse)
  Vue.use(CollapseItem)
  Vue.use(Button)
  Vue.use(Tabbar)
  Vue.use(TabbarItem)
  Vue.use(Form)
  Vue.use(Checkbox)
  Vue.use(Toast)
  Vue.use(Step)
  Vue.use(Steps)
  Vue.use(DropdownMenu)
  Vue.use(DropdownItem)
  Vue.use(Uploader)
}

const install = () => {
  installVant()
  Vue.component(Image.name, Image)
  Vue.component(SplitLabel.name, SplitLabel)
}

export default install
